import { RouletteScene } from '../scenes/RouletteScene';
import MKEvent from '../utils/MKEvent';

export class SceneButton {
	private spriteNormal;
	private spriteHover;
	private scene;
	private clickEvent;
	private pointerDownEvent;
	private pointerUpEvent;
	private pointerOverEvent;
	private pointerOutEvent;
	private isSwitch;
	private offsetX;
	private offsetY;
	private originX;
	private originY;
	private posX;
	private posY;
	private button;
	private buttonShadow;
	private interactable;
	private pressed;
	private pDown;

	constructor(scene: RouletteScene, spriteNormal, spriteHover, isSwitch) {
		this.spriteNormal = spriteNormal;
		this.spriteHover = spriteHover;
		this.scene = scene;
		this.clickEvent = new MKEvent();
		this.pointerDownEvent = new MKEvent();
		this.pointerUpEvent = new MKEvent();
		this.pointerOverEvent = new MKEvent();
		this.pointerOutEvent = new MKEvent();
		this.isSwitch = isSwitch;
	}

	create(offsetX, offsetY, originX, originY, shadow = false) {
		this.offsetX = offsetX;
		this.offsetY = offsetY;
		this.originX = originX;
		this.originY = originY;

		this.posX = this.scene.centerX + this.offsetX;
		this.posY = this.scene.centerY + this.offsetY;

		if (shadow) {
			this.buttonShadow = this.scene.add
				.sprite(this.posX + 3, this.posY + 3, this.spriteNormal)
				.setTint(0x000000)
				.setAlpha(0.3)
				.setOrigin(originX, originY);
		}

		this.button = this.scene.add.sprite(this.posX, this.posY, this.spriteNormal).setOrigin(originX, originY);
		this.button.on('pointerdown', this.pointerDown, this);
		this.button.on('pointerup', this.pointerUp, this);
		this.button.on('pointerover', this.pointerOver, this);
		this.button.on('pointerout', this.pointerOut, this);
		this.button.setInteractive({
			cursor: 'pointer'
		});
		this.interactable = true;
		this.pressed = false;
		this.pDown = false;
	}

	pointerUp() {
		if (!this.interactable) return;
		if (!this.pDown) return;
		this.pDown = false;
		if (!this.isSwitch) this.pressed = false;
		this.button.setTexture(this.pressed ? this.spriteHover : this.spriteNormal);
		this.pointerUpEvent.invoke();
		this.clickEvent.invoke();
	}

	pointerDown() {
		if (!this.interactable) return;
		this.pDown = true;
		if (this.isSwitch) this.pressed = !this.pressed;
		this.button.setTexture(this.spriteHover);
		this.pointerDownEvent.invoke();
		// console.log('button down', arguments);
	}

	pointerOver() {
		if (!this.interactable) return;
		this.pointerOverEvent.invoke();
		// this.button.setTexture(this.spriteHover);
	}

	pointerOut() {
		if (!this.interactable) return;
		this.pointerOutEvent.invoke();
		// this.button.setTexture(this.spriteNormal);
	}

	setInteractable(interactable) {
		this.interactable = interactable;
	}

	addClickEvent(action, context) {
		this.clickEvent.add(action, context);
	}

	release() {
		this.pressed = false;
		this.button.setTexture(this.pressed ? this.spriteHover : this.spriteNormal);
	}

	setPressed() {
		this.pressed = true;
		this.button.setTexture(this.pressed ? this.spriteHover : this.spriteNormal);
	}

	setDepth(depth) {
		this.button.depth = depth;
	}
}
